import theme from '../base'

const avatar = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        '&.big': {
          width: theme.spacing(15),
          height: theme.spacing(15),
          ...theme.typography.body1,
        },
        '&.medium': {
          width: theme.spacing(8),
          height: theme.spacing(8),
          ...theme.typography.body1,
        },
        '&.small': {
          width: theme.spacing(5),
          height: theme.spacing(5),
          ...theme.typography.subtitle1,
        },
        '&.smaller': {
          width: theme.spacing(4),
          height: theme.spacing(4),
          ...theme.typography.subtitle1,
        },
        '&.colorPurple': {
          color: theme.palette.purple.dark,
          backgroundColor: theme.palette.purple.lighter,
        },
        '&.colorTurquoise': {
          color: theme.palette.turquoise.darkest,
          backgroundColor: theme.palette.turquoise.lighter,
        },
        '&.colorGreen': {
          color: theme.palette.green.darkest,
          backgroundColor: theme.palette.green.lighter,
        },
        '&.colorYellow': {
          color: theme.palette.yellow.darkest,
          backgroundColor: theme.palette.yellow.lighter,
        },
      },
      colorDefault: {
        backgroundColor: theme.palette.turquoise.lighter,
        color: theme.palette.turquoise.main,
      },
    },
  },
}

export default avatar
